(ns rothko.link.component
  (:require [rothko.component.core :refer [defcomp]]))

(defcomp link
  {:component-type ::link
   :attrs [:href]}
  [{:keys [appearance]} attrs & children]
  (into [:a.link (merge {:class appearance}
                        attrs)]
        children))
